"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.showAlertFromNotification = exports.showExternalWebsite = exports.showWideAlertHtmlWithTextfieldsAndCheckbox = exports.showWideAlertHtmlWithTextfields = exports.showWideAlertHtmlWithTimeout = exports.showWideAlertHtmlWithoutButtons = exports.showWideAlertHtml = exports.showAlertWithButtonsInNewLine = exports.showAlertHtmlWithTextfields = exports.showAlertHtml = exports.showAlertInDebugMode = exports.showAlert = exports.showWideAlert = exports.showAlertWithoutButton = exports.showAlertWithAutomaticTimeout = exports.showAlertWithOptionsInDebugMode = exports.showAlertWithOptions = exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _Textfield = _interopRequireDefault(require("react-mdl/lib/Textfield"));

var _Checkbox = _interopRequireDefault(require("react-mdl/lib/Checkbox"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _cssConstants = _interopRequireDefault(require("../../targets/cord_sanofi/cssConstants.js"));

var _Dialog = require("react-mdl/lib/Dialog");

var _reactAwesomeModal = _interopRequireDefault(require("react-awesome-modal"));

var _Button = _interopRequireDefault(require("../common/components/Button"));

var _AlertHelper = _interopRequireDefault(require("./AlertHelper.scss"));

var _CordovaExternalWebsite = _interopRequireDefault(require("../common/components/CordovaExternalWebsite/CordovaExternalWebsite"));

var _ThemeStore = _interopRequireDefault(require("../common/components/ThemeStore/ThemeStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _TimeoutHelper = require("./TimeoutHelper");

var _StringHelper = _interopRequireDefault(require("./StringHelper"));

var _strings = require("../../config/strings");

var _BuildConstants = require("../utils/BuildConstants");

var _LogService = require("../KESI2/Services/LogService");

var _StoreComponent2 = _interopRequireDefault(require("../KESI2/Stores/StoreComponent"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var EXTRA_RENDERING_TIME = 50;
var listener = null;
var alerts = [];
var locked = false;

var AlertHelper = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(AlertHelper, _StoreComponent);

  var _super = _createSuper(AlertHelper);

  function AlertHelper(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, AlertHelper);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id.indexOf('actionBtn') > -1 || el.id.indexOf('closeBtn') > -1) {
            el.click();
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTextfieldChange", function (textfieldConfig) {
      return function (evt) {
        if (textfieldConfig.onChange) {
          textfieldConfig.onChange(evt);
        }

        if (textfieldConfig.maxLength && evt.target.value.length > textfieldConfig.maxLength) {
          return;
        }

        textfieldConfig.value = evt.target.value;

        _this.forceUpdate();
      };
    });
    _this.state = {
      currentAlert: null
    };
    _this.focussedTextfields = 0;
    _this.currentlyHandlingClickId = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(AlertHelper.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar']
    }]);

    listener = function listener(alert) {
      alert.visible = true;
      alert.id = _StringHelper["default"].createShortId();
      alert.centeredContent = alert.centeredContent !== false;
      var newAlerts = alerts.slice();
      newAlerts.push(alert);
      alerts = newAlerts;

      _this.showNextAlertIfAny(); // return a function to close this alert


      return function () {
        var updateNotClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (updateNotClose) {
          console.log('update alert');

          _this.forceUpdate();

          return;
        }

        _this.removeAlert(alert);
      };
    };

    return _this;
  }

  (0, _createClass2["default"])(AlertHelper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.showNextAlertIfAny();

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(AlertHelper.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getCurrentAlert",
    value: function getCurrentAlert() {
      var skipCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (alerts.length <= skipCount) {
        return null;
      }

      return alerts[skipCount];
    }
  }, {
    key: "removeAlert",
    value: function () {
      var _removeAlert = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(alert) {
        var _this4 = this;

        var reallyRemoveAlertFromArray;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reallyRemoveAlertFromArray = function reallyRemoveAlertFromArray() {
                  var newAlerts = alerts.slice();
                  var index = newAlerts.indexOf(alert);

                  if (index !== -1) {
                    newAlerts.splice(index, 1);
                  }

                  alerts = newAlerts;
                };

                if (!(alert !== this.state.currentAlert)) {
                  _context.next = 4;
                  break;
                }

                reallyRemoveAlertFromArray();
                return _context.abrupt("return");

              case 4:
                if (!locked) {
                  _context.next = 8;
                  break;
                }

                console.log('can\'t remove dialog because change is locked. Trying again in 100ms');
                setTimeout(function () {
                  _this4.removeAlert(alert);
                }, 100);
                return _context.abrupt("return");

              case 8:
                locked = true; // the hiding transition is not nice if the keyboard is open and is very much nicer if the alert disappers then

                if (alert.textfields) {
                  _context.next = 14;
                  break;
                }

                // hide current alert
                alert.visible = false;
                this.forceUpdate();
                _context.next = 14;
                return (0, _TimeoutHelper.timeout)(500);

              case 14:
                reallyRemoveAlertFromArray();
                locked = false;
                this.showNextAlertIfAny();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeAlert(_x) {
        return _removeAlert.apply(this, arguments);
      }

      return removeAlert;
    }()
  }, {
    key: "showNextAlertIfAny",
    value: function () {
      var _showNextAlertIfAny = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this5 = this;

        var alert, alertTimeout, timeoutCallback;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!locked) {
                  _context2.next = 3;
                  break;
                }

                console.log('can\'t show next alert because change is locked');
                return _context2.abrupt("return");

              case 3:
                if (!(alerts.length === 0)) {
                  _context2.next = 6;
                  break;
                }

                this.setState({
                  currentAlert: null
                });
                return _context2.abrupt("return");

              case 6:
                alert = alerts[0];
                this.setState({
                  currentAlert: alert
                });
                (0, _LogService.pushTravelAndCareLogMessage)('alert', {
                  title: alert.title,
                  message: alert.html || alert.message
                }); // if a timeout was set, hide the alert after that time

                alertTimeout = alert.timeout || 0;

                if (alertTimeout > 0) {
                  timeoutCallback = alert.timeoutCallback || null;
                  setTimeout(function () {
                    _this5.removeAlert(alert);

                    if (timeoutCallback) {
                      timeoutCallback();
                    }
                  }, alertTimeout + EXTRA_RENDERING_TIME); // timeout + some extra rendering time
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showNextAlertIfAny() {
        return _showNextAlertIfAny.apply(this, arguments);
      }

      return showNextAlertIfAny;
    }()
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton(alert) {
      var _this6 = this;

      if (!alert) {
        console.warn('no alert given in renderCloseButton');
        return null;
      }

      if (alert.showCloseButton) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          tabIndex: 0,
          id: 'closeBtn',
          className: _AlertHelper["default"].closeButton,
          theme: "close",
          onClick: function onClick() {
            _this6.removeAlert(alert);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          name: "times"
        }));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var alert = this.state.currentAlert;

      if (!alert) {
        return null;
      }

      var title = alert ? alert.title : null;
      var message = alert ? alert.message : null;
      var messageHtml = alert ? alert.html : null;
      var size = alert ? alert.size : null;
      var newLineButton = alert ? alert.newLineButton : null;
      var externalUrl = alert ? alert.externalUrl : null;
      var sendsMessages = alert ? alert.sendsMessages : null;
      var onLoadErrorExternal = alert ? alert.onLoadError : null;
      var key = 0;
      var inputKey = 0;
      var buttonDefinitions = !alert.buttons ? [{
        label: 'OK',
        callback: function callback() {}
      }] : alert.buttons;
      var buttons = buttonDefinitions ? buttonDefinitions.map(function (button, index) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          tabIndex: 0,
          id: "actionBtn_".concat(_StringHelper["default"].createShortId()),
          showBorder: false,
          key: key++,
          theme: button.theme ? button.theme : 'default',
          forcedColor: button.forcedColor ? button.forcedColor : null,
          disabled: button.enabledIf ? !button.enabledIf() : false,
          isDefault: button.isDefault,
          onClick: function onClick() {
            (0, _LogService.pushTravelAndCareLogMessage)('alert_button_push', {
              title: title,
              message: messageHtml || message,
              chosenButton: button.label
            });

            if (button.remove || typeof button.remove === 'undefined') {
              _this7.removeAlert(alert);
            }

            if (button.callback) {
              button.callback();
            }
          }
        }, button.label);
      }) : null;
      var textfields = null;
      var error = null;
      var htmlError = null;
      var checkboxes = null;
      var addExtraCheckBoxHeight = false;
      checkboxes = alert.checkboxes ? alert.checkboxes.map(function (box) {
        addExtraCheckBoxHeight = box.addExtraHeight;
        return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          key: inputKey++,
          className: box.className,
          ref: box.ref,
          label: /*#__PURE__*/_react["default"].createElement("span", {
            onClick: function onClick() {
              _this7.removeAlert(alert);

              box.onLabelClick();
            },
            style: {
              fontSize: '12px'
            },
            dangerouslySetInnerHTML: {
              __html: box.label
            }
          }),
          onChange: box.onChange,
          ripple: box.ripple,
          style: box.style,
          checked: box.checked ? box.checked() : false
        });
      }) : null;
      var textfieldDefaultValues = [];
      textfields = alert.textfields ? alert.textfields.map(function (textfield, index) {
        if (textfield.defaultValue) {
          textfieldDefaultValues.push({
            id: textfield.id,
            defaultValue: textfield.defaultValue
          });
        }

        var onBlur = function onBlur() {
          _this7.focussedTextfields -= 1;

          if (alert.scrollToTopOnBlur && _DeviceInfoHelper["default"].isiOS()) {
            /**
             Fixes a bug where when we have 2 textfields and one loses focus because user clicked on the other one (onBlur),
             the alert moves weirdly due to the window.scrollTo. With the timeout we wait and check if another textfield has been focussed
             and do not scroll if so. Timeout of 0 is enough since it will move back in the execution queue this way (I think).
             */
            setTimeout(function () {
              if (_this7.focussedTextfields === 0) {
                window.scrollTo(0, 0);
              }
            }, 0);
          }

          if (textfield.onBlur) {
            textfield.onBlur.apply(textfield, arguments);
          }
        };

        var onFocus = function onFocus() {
          _this7.focussedTextfields += 1;

          if (textfield.onFocus) {
            textfield.onFocus.apply(textfield, arguments);
          }
        };

        if (_DeviceInfoHelper["default"].isiOS()) {
          return /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
            id: textfield.id,
            inputClassName: textfield.className,
            style: (0, _assign["default"])({
              minWidth: 220
            }, textfield.style),
            ref: textfield.ref,
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: "false",
            key: inputKey++,
            onChange: _this7.onTextfieldChange(textfield),
            onFocus: onFocus,
            onBlur: onBlur,
            type: textfield.type || 'text',
            floatingLabel: true,
            label: textfield.label,
            rows: textfield.type === 'textarea' ? 5 : null,
            value: textfield.value,
            disabled: textfield.disabled || false
          });
        }

        if (_DeviceInfoHelper["default"].isBrowser()) {
          textfield.onKeyPress = function (e) {
            // enter
            if (e.charCode === 13 && (0, _isArray["default"])(buttons)) {
              var defaultButton = buttons.find(function (b) {
                return b.props.isDefault;
              });

              if (defaultButton) {
                defaultButton.props.onClick();
              } else {
                if (buttons.length === 1) {
                  var _defaultButton = buttons[0];

                  _defaultButton.props.onClick();
                }
              }
            }
          };
        }

        return /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
          id: textfield.id,
          inputClassName: textfield.className,
          style: (0, _assign["default"])({
            minWidth: 220
          }, textfield.style),
          ref: textfield.ref,
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: "false",
          key: inputKey++,
          onChange: _this7.onTextfieldChange(textfield),
          onFocus: onFocus,
          onBlur: onBlur,
          type: textfield.type || 'text',
          floatingLabel: true,
          label: textfield.label,
          rows: textfield.type === 'textarea' ? 5 : null,
          value: textfield.value,
          disabled: textfield.disabled || false,
          onKeyPress: textfield.onKeyPress
        });
      }) : null;
      error = alert.error ? alert.error : null;
      htmlError = alert.htmlError ? alert.htmlError : null;
      setTimeout(function () {
        textfieldDefaultValues.forEach(function (idValue) {
          var element = document.getElementById(idValue.id);

          if (element) {
            element.value = idValue.defaultValue;
          }
        });
      }, 200);
      var titleElement = title ? /*#__PURE__*/_react["default"].createElement(_Dialog.DialogTitle, {
        className: _AlertHelper["default"].title
      }, title) : null;
      var contentElement;

      if (message) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_Dialog.DialogContent, {
          className: "".concat(_AlertHelper["default"].content, " ").concat(alert.centeredContent ? _AlertHelper["default"].centered : '')
        }, message);
      } else if (messageHtml) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_Dialog.DialogContent, {
          className: "".concat(_AlertHelper["default"].content, " ").concat(alert.centeredContent ? _AlertHelper["default"].centered : ''),
          dangerouslySetInnerHTML: {
            __html: messageHtml
          }
        });
      } else if (externalUrl) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_CordovaExternalWebsite["default"], {
          url: externalUrl,
          sendsMessages: sendsMessages,
          onLoadErrorBeforeAlert: function onLoadErrorBeforeAlert() {
            return _this7.removeAlert(alert);
          },
          onLoadError: onLoadErrorExternal,
          closeFunc: function closeFunc() {
            return _this7.removeAlert(alert);
          },
          closeAndRetryFunc: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this7.removeAlert(alert);

                    _context3.next = 3;
                    return (0, _TimeoutHelper.timeout)(400);

                  case 3:
                    alert.onRetry();

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))
        });
      }

      var errorElement = null;

      if (error) {
        errorElement = /*#__PURE__*/_react["default"].createElement(_Dialog.DialogContent, {
          className: _AlertHelper["default"].error
        }, error);
      } else if (htmlError) {
        errorElement = /*#__PURE__*/_react["default"].createElement(_Dialog.DialogContent, {
          className: _AlertHelper["default"].error,
          dangerouslySetInnerHTML: {
            __html: htmlError
          }
        });
      }

      var checkElement = checkboxes ? /*#__PURE__*/_react["default"].createElement(_Dialog.DialogActions, {
        className: "".concat(_AlertHelper["default"].checkActions).concat(addExtraCheckBoxHeight ? " ".concat(_AlertHelper["default"].extraCheckHeight) : '')
      }, checkboxes) : null;
      var inputElement = textfields ? /*#__PURE__*/_react["default"].createElement(_Dialog.DialogActions, {
        className: _AlertHelper["default"].inputActions
      }, textfields) : null;
      var actionsElementStyle = _AlertHelper["default"].buttonActions;

      if (newLineButton) {
        actionsElementStyle += " ".concat(_AlertHelper["default"].fullWidthInput);
      }

      if (alert.buttons && alert.buttons.length > 0) {
        alert.buttons.forEach(function (button) {
          if (button.theme === 'pwReset') {
            actionsElementStyle += " ".concat(_AlertHelper["default"].extraPadding);
          }

          if (button.theme === 'fullwidth') {
            actionsElementStyle += " ".concat(_AlertHelper["default"].fullWithButton);
          }
        });
      }

      var actionsElement = buttons && buttons.length > 0 ? /*#__PURE__*/_react["default"].createElement(_Dialog.DialogActions, {
        className: actionsElementStyle
      }, buttons) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _AlertHelper["default"].placeHolder
      });
      var div = null;

      if (_config["default"].requiredFeature === 'ergoquiz') {
        var width;
        var height = 'auto';

        if (size === 'fullscreen') {
          //        width = window.screen.availWidth * 0.9
          //        height = window.screen.availHeight * 0.9
          width = window.innerWidth * 0.9;
          height = window.innerHeight * 0.9;
        } else if (size === 'large') {
          //        width = window.screen.availWidth * 0.8
          width = window.innerWidth * 0.8;
        } else {
          //        width = window.screen.availWidth * 0.5
          width = window.innerWidth * 0.5;
        }

        div = /*#__PURE__*/_react["default"].createElement("div", {
          key: alert.id,
          className: _AlertHelper["default"].center
        }, /*#__PURE__*/_react["default"].createElement(_reactAwesomeModal["default"], {
          visible: alert.visible,
          width: width,
          height: height,
          effect: "fadeInUp",
          className: _AlertHelper["default"].dialog
        }, titleElement, contentElement, errorElement, actionsElement));
      } else {
        var _width;

        var _height = 'auto';

        if (size === 'fullscreen') {
          //        width = window.screen.availWidth * 0.9
          //        height = window.screen.availHeight * 0.9
          _width = window.innerWidth * 0.9;
          _height = window.innerHeight * 0.9;
        } else if (size === 'large') {
          //        width = DeviceInfoHelper.isBrowser() ? (window.screen.availHeight > window.screen.availWidth ? window.screen.availWidth * 0.9 : window.screen.availWidth * 0.5) : window.screen.availWidth * 0.8
          _width = _DeviceInfoHelper["default"].isBrowser() ? window.innerHeight > window.innerWidth ? window.innerWidth * 0.9 : window.innerWidth * 0.3 : window.innerWidth * 0.8;
        } else {
          //        width = DeviceInfoHelper.isBrowser() ? (window.screen.availHeight > window.screen.availWidth ? window.screen.availWidth * 0.6 : window.screen.availWidth * 0.2) : window.screen.availWidth * 0.5
          _width = _DeviceInfoHelper["default"].isBrowser() ? window.innerHeight > window.innerWidth ? window.innerWidth * 0.6 : window.innerWidth * 0.2 : window.innerWidth * 0.5;
        }

        div = /*#__PURE__*/_react["default"].createElement("div", {
          key: alert.id,
          className: "".concat(_AlertHelper["default"].center, " ").concat(_AlertHelper["default"].modal, " equizzer-modal")
        }, /*#__PURE__*/_react["default"].createElement(_reactAwesomeModal["default"], {
          visible: alert.visible,
          width: _width,
          height: _height // effect={alert.effect || 'fadeInUp'}
          ,
          className: _AlertHelper["default"].dialog,
          styles: alert.effect === 'noOverlay' ? {
            border: '1px solid grey',
            backgroundColor: _cssConstants["default"].colors.modalBackground ? _cssConstants["default"].colors.modalBackground : 'white'
          } : {
            backgroundColor: _cssConstants["default"].colors.modalBackground ? _cssConstants["default"].colors.modalBackground : 'white'
          },
          background: _config["default"].tileBackgroundImage ? "url(".concat(_config["default"].tileBackgroundImage, ") no-repeat center") : alert.effect === 'noOverlay' ? 'rgba(255,255,255,0.0)' : ''
        }, alert && this.renderCloseButton(alert), titleElement, contentElement, errorElement, inputElement, checkElement, actionsElement));
      }

      return div;
    }
  }]);
  return AlertHelper;
}(_StoreComponent2["default"]);
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports["default"] = AlertHelper;

var showAlertWithOptions = function showAlertWithOptions(alert) {
  var alertToUse = (0, _assign["default"])({
    message: null,
    title: null,
    size: 'large',
    showCloseButton: true
  }, alert);

  if (listener) {
    return listener(alertToUse);
  } // if listener not yet present due to early show of the alert
  // there is no return value. Sorry for that.


  setTimeout(function () {
    showAlertWithOptions(alert);
  }, 300);
  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithOptions = showAlertWithOptions;

var showAlertWithOptionsInDebugMode = function showAlertWithOptionsInDebugMode(alert) {
  if (_BuildConstants.NODE_ENV !== 'production') {
    return showAlertWithOptions(alert);
  } // if listener not yet present due to early show of the alert
  // there is no return value. Sorry for that.


  setTimeout(function () {
    showAlertWithOptionsInDebugMode(alert);
  }, 300);
  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithOptionsInDebugMode = showAlertWithOptionsInDebugMode;

var showAlertWithAutomaticTimeout = function showAlertWithAutomaticTimeout(message, title, timeout, timeoutCallback) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var buttons = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var copyButtons = [].concat(buttons);

  if (listener) {
    return listener({
      message: message,
      title: title,
      buttons: copyButtons,
      timeout: timeout,
      timeoutCallback: timeoutCallback,
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithAutomaticTimeout = showAlertWithAutomaticTimeout;

var showAlertWithoutButton = function showAlertWithoutButton(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isWideAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (listener) {
    return listener({
      message: message,
      title: title,
      size: isWideAlert ? 'large' : 'small',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithoutButton = showAlertWithoutButton;

var showWideAlert = function showWideAlert(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isWideAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var buttons = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      message: message,
      title: title,
      buttons: copyButtons,
      size: isWideAlert ? 'large' : 'small',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlert = showWideAlert;

var showAlert = function showAlert(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 ? arguments[3] : undefined;
  return showWideAlert(message, title, showCloseButton, false, buttons);
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlert = showAlert;

var showAlertInDebugMode = function showAlertInDebugMode(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (_BuildConstants.NODE_ENV !== 'production') {
    if (listener) {
      var copyButtons = [].concat(buttons);

      if (copyButtons.length === 0) {
        // add a default button
        copyButtons.push({
          label: 'OK',
          callback: function callback() {}
        });
      }

      return listener({
        message: "[DEBUG] ".concat(message),
        title: title,
        buttons: copyButtons,
        showCloseButton: showCloseButton
      });
    }
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertInDebugMode = showAlertInDebugMode;

var showAlertHtml = function showAlertHtml(htmlMessage, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (listener) {
    var copyButtons = buttons;

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      buttons: copyButtons,
      size: 'small',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 * @param htmlMessage
 * @param title
 * @param htmlError
 * @param textfields
 * @param showCloseButton
 * @param effect
 * @param buttons
 * @param scrollToTopOnBlur -- ONLY ON IOS -- fixes a bug in iOS 12 when build with Xcode 10 when hiding the keyboard is not fully working.
 * @returns {*}
 */


exports.showAlertHtml = showAlertHtml;

var showAlertHtmlWithTextfields = function showAlertHtmlWithTextfields(htmlMessage, title, htmlError) {
  var textfields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{
    label: '',
    type: 'text',
    onChange: function onChange() {},
    ref: 'customId',
    className: ''
  }];
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var effect = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var buttons = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var scrollToTopOnBlur = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      htmlError: htmlError,
      effect: effect,
      textfields: textfields,
      buttons: copyButtons,
      size: 'small',
      showCloseButton: showCloseButton,
      scrollToTopOnBlur: scrollToTopOnBlur
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertHtmlWithTextfields = showAlertHtmlWithTextfields;

var showAlertWithButtonsInNewLine = function showAlertWithButtonsInNewLine(htmlMessage, title, newLineButton) {
  var showCloseButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var buttons = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      newLineButton: newLineButton,
      buttons: copyButtons,
      size: 'large',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithButtonsInNewLine = showAlertWithButtonsInNewLine;

var showWideAlertHtml = function showWideAlertHtml(htmlMessage, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var centeredContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      buttons: copyButtons,
      size: 'large',
      showCloseButton: showCloseButton,
      centeredContent: centeredContent
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtml = showWideAlertHtml;

var showWideAlertHtmlWithoutButtons = function showWideAlertHtmlWithoutButtons(htmlMessage, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var centeredContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (listener) {
    return listener({
      html: htmlMessage,
      title: title,
      buttons: buttons,
      size: 'large',
      showCloseButton: showCloseButton,
      centeredContent: centeredContent
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtmlWithoutButtons = showWideAlertHtmlWithoutButtons;

var showWideAlertHtmlWithTimeout = function showWideAlertHtmlWithTimeout(htmlMessage, title, timeout, timeoutCallback) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var buttons = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      buttons: copyButtons,
      size: 'large',
      timeout: timeout,
      timeoutCallback: timeoutCallback,
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead
 * @param htmlMessage
 * @param title
 * @param htmlError
 * @param textfields
 * @param showCloseButton
 * @param effect
 * @param buttons
 * @param scrollToTopOnBlur -- ONLY ON IOS -- fixes a bug in iOS 12 when build with Xcode 10 when hiding the keyboard is not fully working.
 * @returns {*}
 */


exports.showWideAlertHtmlWithTimeout = showWideAlertHtmlWithTimeout;

var showWideAlertHtmlWithTextfields = function showWideAlertHtmlWithTextfields(htmlMessage, title, htmlError) {
  var textfields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{
    label: '',
    type: 'text',
    onChange: function onChange() {},
    ref: 'customId',
    className: ''
  }];
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var effect = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var buttons = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var scrollToTopOnBlur = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      htmlError: htmlError,
      effect: effect,
      textfields: textfields,
      buttons: copyButtons,
      size: 'large',
      showCloseButton: showCloseButton,
      scrollToTopOnBlur: scrollToTopOnBlur
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead
 * @param htmlMessage
 * @param title
 * @param htmlError
 * @param textfields
 * @param checkboxes
 * @param showCloseButton
 * @param effect
 * @param buttons
 * @param scrollToTopOnBlur -- ONLY ON IOS -- fixes a bug in iOS 12 when build with Xcode 10 when hiding the keyboard is not fully working.
 * @returns {*}
 */


exports.showWideAlertHtmlWithTextfields = showWideAlertHtmlWithTextfields;

var showWideAlertHtmlWithTextfieldsAndCheckbox = function showWideAlertHtmlWithTextfieldsAndCheckbox(htmlMessage, title, htmlError) {
  var textfields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{
    label: '',
    type: 'text',
    onChange: function onChange() {},
    ref: 'customId',
    className: ''
  }];
  var checkboxes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [{
    checked: false,
    label: '',
    onChange: function onChange() {},
    ref: 'customId',
    className: '',
    ripple: true
  }];
  var showCloseButton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var effect = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var buttons = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var scrollToTopOnBlur = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      htmlError: htmlError,
      effect: effect,
      textfields: textfields,
      checkboxes: checkboxes,
      buttons: copyButtons,
      size: 'large',
      showCloseButton: showCloseButton,
      scrollToTopOnBlur: scrollToTopOnBlur
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtmlWithTextfieldsAndCheckbox = showWideAlertHtmlWithTextfieldsAndCheckbox;

var showExternalWebsite = function showExternalWebsite(url, onError, sendsMessages, onRetry) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (listener) {
    return listener({
      externalUrl: url,
      sendsMessages: sendsMessages,
      onLoadError: onError,
      showCloseButton: showCloseButton,
      onRetry: onRetry,
      size: 'fullscreen'
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showExternalWebsite = showExternalWebsite;

var showAlertFromNotification = function showAlertFromNotification(message) {
  if (message.name === 'alert') {
    try {
      var data = JSON.parse(message.data);
      var title = data.title || (0, _strings.getString)('NOTIFICATION');
      var content = data.html;

      if (!content || content.trim().length === 0) {
        console.warn('did receive remote ably message, but html was empty', content);
      } else {
        showWideAlertHtml(content, title);
      }

      return true;
    } catch (error) {
      console.warn('did receive remote ably message, but an error occurred', message, error);
      return true;
    }
  }

  return false;
};

exports.showAlertFromNotification = showAlertFromNotification;